import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {IJobDashboardModel, IJobModel, IJobRequest} from './JobModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const JOB_CREATE_URL = `${API_URL}api/v1/job/create`
export const JOB_GET_ALL_URL = `${API_URL}api/v1/job/getAll`
export const JOB_GET_BY_ID_URL = `${API_URL}api/v1/job/getById/`
export const JOB_UPDATE_URL = `${API_URL}api/v1/job/update/`
export const JOB_DELETE_URL = `${API_URL}api/v1/job/delete/`

export function loadJobs(
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<IJobModel>>>> {
  return corporateApi.get(JOB_GET_ALL_URL, {params: {page, size}})
}

export function getJobById(jobId: string): Promise<AxiosResponse<ApiResponse<IJobModel>>> {
  return corporateApi.get(JOB_GET_BY_ID_URL + jobId)
}

export function createJob(job: IJobRequest): Promise<AxiosResponse<ApiResponse<IJobModel>>> {
  return corporateApi.post(JOB_CREATE_URL, job)
}

export function updateJob(
  jobId: string,
  job: IJobRequest
): Promise<AxiosResponse<ApiResponse<IJobModel>>> {
  return corporateApi.patch(JOB_UPDATE_URL + jobId, job)
}

export function getJobDashboard(jobId: string): Promise<AxiosResponse<ApiResponse<IJobDashboardModel>>> {
  return corporateApi.get(`${API_URL}api/v1/job/dashboard/${jobId}`)
}

export function deleteJob(jobId: string) {
  return corporateApi.delete(JOB_DELETE_URL + jobId)
}
